export class TestEmailModalComponent implements ng.IComponentOptions {
  public controller: any = TestEmailController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string =
    `<div class="modal-header">
      <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <h4 class="modal-title" id="testEmailModal">Test Email</h4>
    </div>
    <div class="modal-body">
      <form class="form-horizontal" name="$ctrl.testEmailForm">
        <div class="form-group">
          <label for="emailType" class="col-sm-3 control-label">Email Type</label>
          <div class="col-sm-9">
          <ui-select ng-model="$ctrl.form.emailType" required name="emailType">
            <ui-select-match placeholder="Select Email Type">
              <span ng-bind="$select.selected.name"></span>
            </ui-select-match>
            <ui-select-choices repeat="item.type as item in ($ctrl.emailTypes | filter: $select.search)">
              <span ng-bind="item.name"></span>
            </ui-select-choices>
          </ui-select>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">Email</label>
          <div class="col-sm-9">
            <input class="form-control" type="email" placeholder="Email Address" ng-model="$ctrl.form.email" name="email" required/>
            <span class="text-warning text-small" ng-show="$ctrl.testEmailForm.$dirty && $ctrl.testEmailForm.email.$dirty && $ctrl.testEmailForm.email.$invalid">Invalid Email Format</span>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()">Close</button>
    <button type="button" class="btn btn-primary" ng-click="$ctrl.send()">Send</button>
    </div>
    `;
}

export class TestEmailController {
  public static $inject: Array<string> = ["$http"];
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public resolve: any;
  public form: any;
  public testEmailForm: ng.IFormController;
  public emailTypes: Array<any>;
  constructor(private $http: ng.IHttpService) {
    this.emailTypes = [
      {name: "Registration", type: "register"},
      {name: "Approval", type: "approve"},
      {name: "Rejection", type: "reject"},
      {name: "Forget Password", type: "forget_pw"},
      {name: "Reminder", type: "reminder"},
      {name: "Notification", type: "org_dataset"}
    ];
  }
  public cancel() {
    this.modalInstance.dismiss("canceled");
  }
  public send() {
    if (this.testEmailForm.$valid) {
      this.$http.post(`${BASE}/api/configuration/testemail`, this.form).then((d) => {
        this.modalInstance.close(this.form.email);
      })
      .catch(() => {
        this.modalInstance.close(false);
      })
    }
  }
}
